

import { AngularFirestore } from 'angularfire2/firestore';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'PropiedadPasajero' // nombre del pipe en las directivas
})

export class PropiedadPasajeroPipe implements PipeTransform {

    constructor(private afs: AngularFirestore){}

    // Métdodo a implementar siempre
    transform(idCliente:string, propiedad:string, idPasajero:string):any{
        debugger
        return this.afs.collection('pasajerosPorCliente').doc(idCliente).collection("pasajeros").doc(idPasajero).valueChanges().map(data =>{
            let resultado='';
            if(data)
                resultado= data[propiedad];
            return resultado
        });
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/propiedad-pasajero.pipe.ts